(() => {
  if (window.pannolinoDeliveryEstimateStarted) return;
  window.pannolinoDeliveryEstimateStarted = true;
  const localClock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kolkata', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });
  const deliveryClock = new Intl.DateTimeFormat('en-IN', {
    timeZone: 'Asia/Kolkata', hour: 'numeric', minute: '2-digit', hour12: true
  });
  function updateEstimate() {
    const now = new Date();
    const parts = localClock.formatToParts(now);
    const hour = Number(parts.find(part => part.type === 'hour').value);
    const minute = Number(parts.find(part => part.type === 'minute').value);
    const afterCutoff = hour >= 18;
    const arrival = new Date(now.getTime() + 2 * 60 * 60 * 1000);
    const time = hour < 10 ? '12 pm' : deliveryClock.format(arrival).replace(/\s+/g, ' ').toLowerCase();
    document.querySelectorAll('[data-delivery-estimate]').forEach(element => {
      const template = afterCutoff ? element.dataset.tomorrow : element.dataset.today;
      const estimate = template.replace('{time}', time);
      if (element.textContent !== estimate) element.textContent = estimate;
    });
  }
  function tick() {
    updateEstimate();
    window.setTimeout(tick, 60000 - Date.now() % 60000);
  }
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateEstimate();
  });
  window.addEventListener('pageshow', updateEstimate);
  document.addEventListener('shopify:section:load', updateEstimate);
  new MutationObserver(updateEstimate).observe(document.body, { childList: true, subtree: true });
  tick();
})();
